import * as React from 'react';

// components
import Button from 'components/Button';
import Hovercard from 'components/Hovercard';
import HovercardBody from 'components/HovercardBody';

type Props = {
  onTranslateMessage: () => void;
}

// Generic presentation component that should (hopefully) be reusable across
// both ChatBroadcast and Chat composers.
export default class TranslationsHoverCard extends React.Component<Props> {
  render() {
    return (
      <Hovercard {...this.props} className="LanguageHoverCard">
        <HovercardBody className="LanguageHoverCard-body">
            <Button onClick={this.props.onTranslateMessage}>Translate</Button>
        </HovercardBody>
      </Hovercard>
    );
  }
}
